import { declareFilter} from '/vodalys/vvuejs'

export default class VLocale
{
    constructor() 
    {
        let _this = this;
        
        jQuery.ajax({
            url: '/vlocale/strings',
            success: function (result) {
                _this.strings = JSON.parse(result);
            },
            async: false
        });
    }

    lang () 
    {
        if (this.strings.user_langcode) {
            return this.strings.user_langcode;
        }
        
        var browserLanguage = navigator.language || navigator.userLanguage || navigator.browserLanguage;
        // vconsole => EN
        // page => navigator language
        browserLanguage = browserLanguage.substr(0,2);
        
        return browserLanguage ? browserLanguage :  this.strings.default_langcode;
    }

}

let vLocale = new VLocale();

declareFilter('vtranslate', function (text, variables) 
{
    variables = variables || {};
    var lang = vLocale.lang();
    
    if (vLocale.strings[lang] && vLocale.strings[lang][text])
    {
        text = vLocale.strings[lang][text];
    }
    Object.keys(variables).forEach(function(key) {
        text = text.replace(key, variables[key]);
    });
    return text;
})